export const MESSAGE_DIFFUSION_USERS_ADDED = 'MESSAGE_DIFFUSION_USERS_ADDED';
export const MESSAGE_DIFFUSION_OPEN_MODAL = 'MESSAGE_DIFFUSION_OPEN_MODAL';
export const MESSAGE_DIFFUSION_CLEAR_USERS = 'MESSAGE_DIFFUSION_CLEAR_USERS';
export const MESSAGE_DIFFUSION_CLOSE_MODAL = 'MESSAGE_DIFFUSION_CLOSE_MODAL';

export const openDiffusionModal = () => (dispatch, getState) => {
  dispatch({
    type: MESSAGE_DIFFUSION_OPEN_MODAL,
  });
};

export const closeDiffusionModal = () => (dispatch, getState) => {
  dispatch({
    type: MESSAGE_DIFFUSION_CLOSE_MODAL,
  });
};

export const clearUserSelection = () => (dispatch, getState) => {
  dispatch({
    type: MESSAGE_DIFFUSION_CLEAR_USERS,
  });
};

export const onUserSelected = users => (dispatch, getState) => {
  dispatch({
    type: MESSAGE_DIFFUSION_USERS_ADDED,
    payload: {
      users,
    },
  });
};



// WEBPACK FOOTER //
// ./src/modules/messaging/actions/diffusion.js